<template>
  <section class="navbar-container">
    <a href="/" class="logo-wrapper cursor-pointer">
      <img class="logo" :src="require('@/assets/images/logo.png')" />
    </a>

    <div class="links-wrapper fz-16 fw-600">
      <a
        v-scroll-to="{
          el: '#become-ganga7s-partner',
          duration: 1000,
          easing: 'ease-in-out',
        }"
        href="#"
        title="Contact Us"
        class="link apply-link"
        target="_blank"
        >Apply Now</a
      >
      <a href="https://www.ganga7.com/" class="link website-link"
        >GANGA7 Website</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style lang="scss">
.navbar-container {
  @include mq(mbl) {
    padding: 0 vw-mbl($page-margin-x-mbl);
  }

  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 60px;
  padding: 0 vw-dsk($page-margin-x);

  background-color: #000;

  .links-wrapper {
    display: flex;
    align-items: center;

    .link {
      padding: 0 10px;

      background-image: var(--gradient-2);
      background-clip: text;

      line-height: 1.1;
      letter-spacing: 1px;

      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .apply-link {
      display: flex;
      align-items: center;

      &::after {
        position: absolute;
        right: 0;

        width: 1px;
        height: 25px;

        background-color: #979797;

        content: "";
      }
    }
  }

  .logo {
    height: 27px;
    margin-right: 10px;
  }
}
</style>
